import { Ace2WarrntyItemAction } from "./types";

export const fetchOptions = () =>
  ({
    type: Ace2WarrntyItemAction.FETCH_OPTIONS,
  }) as const;

export const setOptions = (payload) =>
  ({
    type: Ace2WarrntyItemAction.SET_OPTIONS,
    payload,
  }) as const;

export const cleanUpState = () =>
  ({
    type: Ace2WarrntyItemAction.CLEAN_UP,
  }) as const;

export const addWarrntyItem = (payload) =>
  ({
    type: Ace2WarrntyItemAction.ADD,
    payload,
  }) as const;

export const uploadInvoice = (payload) =>
  ({
    type: Ace2WarrntyItemAction.UPLOAD_INVOICE,
    payload,
  }) as const;

export const setWarrntyClaimId = (payload) =>
  ({
    type: Ace2WarrntyItemAction.SET_WARRNTYID_CLAIMID,
    payload,
  }) as const;

export const setInvoiceURL = (payload) =>
  ({
    type: Ace2WarrntyItemAction.SET_INVOICE_URL,
    payload,
  }) as const;

export const showSuccesModal = () =>
  ({
    type: Ace2WarrntyItemAction.SHOW_SUCCES_MODAL,
  }) as const;

export const hideSuccesModal = () =>
  ({
    type: Ace2WarrntyItemAction.HIDE_SUCCES_MODAL,
  }) as const;
